// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__2_E07","label":"LabeledBox_label__2QfiJ"};